<template>
  <div>
    <button @click.prevent="resetForm(true)" class="btn btn-default green-grassy">
      {{ $t('Выбрать') }}
    </button>
    <v-dialog v-model="searchDialog" max-width="640">
      <v-card class="modal hunter-modal">
        <div class="modal-head">
          <template>
            {{ $t('Поиск') }}
          </template>
          <v-btn color="modal-close" @click="resetForm()">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="searchHunter"
          >
            <v-row>
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('ФИО/ПИН') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('ФИО/ПИН')"/>
              </v-col>
              <v-col class="input-field">
                <v-text-field
                  v-model="field"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <!--Кнопки действии-->
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Найти') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="resetForm()"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
          <template v-if="hunters.length > 0">
            <label>{{ $t('Результат') }}:</label>
            <p v-bind:key="hunter.id" v-for="hunter in hunters">
              <a  href="#" class="set-hunter-link" @click.prevent="setHunterData(hunter.id, hunter.fio)">
                {{ hunter.fio }}<span v-if="hunter.pin"> - {{ hunter.pin }}</span> - {{ hunter.country }}
              </a>
            </p>
          </template>
          <template v-if="createForm">
            <CreateModal @hunter-new="setHunterNewData($event)" :refCountry="refCountry" :KyrgyzstanCountry="KyrgyzstanCountry" :permitReport="true"/>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fieldInfo from '@/components/app/fieldInfo'
import Hunters from '@/model/hunters'
import CreateModal from '@/components/hunter/CreateModal'

export default {
  props: {
    type: Number
  },
  components: {
    CreateModal,
    fieldInfo
  },
  data: () => ({
    searchDialog: false,
    field: null,
    hunters: [],
    createForm: false,
    refCountry: [],
    KyrgyzstanCountry: null
  }),
  methods: {
    resetForm (flag = false) {
      this.field = null
      this.searchDialog = flag
      this.hunters = []
      this.createForm = false
    },
    searchHunter () {
      if (!this.field) {
        this.$noty.error(this.$i18n.t('Введите ФИО/ПИН'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      Hunters.getListByFioOrPin(this.type, this.field).then((response) => {
        if (response.status === 200) {
          this.hunters = response.data.hunters
          this.refCountry = response.data.refCountry
          this.KyrgyzstanCountry = response.data.KyrgyzstanCountry
          this.createForm = true
        }
      })
        .catch((error) => {
          console.log(error)
        })
    },
    // установка данных выбранного охотника
    setHunterNewData (result) {
      this.setHunterData(result.id, result.fio)
    },
    // установка данных выбранного охотника
    setHunterData (id, fio) {
      this.$emit('hunter-data', {
        id: id,
        fio: fio
      })
      this.resetForm()
    }
  }
}
</script>

<style scoped>
.set-hunter-link {
  color: inherit;
}
</style>
